import { AlignmentType, HeadingLevel, ImageRun, Paragraph, TextRun, TextWrappingSide, TextWrappingType, WidthType } from 'docx';
import firstimg from '../../../../../../Assests/ReportImages/firstimage.png'
import objective from '../../../../../../Assests/ReportImages/penImage.png'
const heading1 = await fetch(firstimg).then(response => response.blob())
const penimage1 = await fetch(objective).then(response => response.blob())

const firstImage = new ImageRun({
    type: 'png',
    data: await heading1.arrayBuffer(),
    transformation: { width: 150, height: 120 },
});

export const objectiveImage = new Paragraph({
    indent: { left: 130 },
    spacing: { before: 400, },

    alignment: AlignmentType.LEFT,
    children: [firstImage]
})

export const objectiveHeading = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 100, },
    children: [new TextRun({
        text: "1. Objectives",
        size: 40,
        color: "0189f9",
        font: "Gill Sans MT(Headings)",
        bold: true,
        italics: false

    })],
    heading: HeadingLevel.HEADING_2,
})

export function objectiveText(customerName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        indent: { left: 600 },
        // spacing: { before: 150 },
        spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
        alignment: AlignmentType.JUSTIFIED,
        children: [

            new TextRun({
                text: `ISECURION security testing team performed the Secure Source Code Audit of Application belonging to ${customerName}. The exercise was to identify vulnerabilities in the Source Code that can be exploited by malicious users from the Internet/Intranet and also to indentify if a security weakness in the application could lead to application and/or system compromise. The overall objective and goal of this engagement was to:`,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
        ]
    })
}

export const objectiveSecondImage = new Paragraph({
    children: [
        new ImageRun({
            type: 'png',
            data: await penimage1.arrayBuffer(),
            transformation: { width: 170, height: 170 },
            floating: {
                horizontalPosition: { offset: 5790000 },
                verticalPosition: { offset: 2000000 },
                wrap: { type: TextWrappingType.SQUARE, side: TextWrappingSide.BOTH_SIDES },
                margins: { top: 201440, bottom: 201440 },
            },
        })
    ]
})

export const bulletOne = new Paragraph({
    indent: { left: 1200 },
    bullet: { level: 0 },
    spacing: { line: 276, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Identify Vulnerabilities in application source code by manual and automated methodologies.",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})

export const bulletTwo = new Paragraph({
    indent: { left: 1200 },
    bullet: { level: 0 },
    spacing: { line: 276, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Identify the extent to which the application under the purview of this exercise is vulnerable to threats.",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})


export const bulletThree = new Paragraph({
    indent: { left: 1200 },
    bullet: { level: 0 },
    spacing: { line: 276, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Recommended steps that need to be in place to mitigate the risks that arise due to the existence of these vulnerabilities.",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})

export const bulletFour = new Paragraph({
    indent: { left: 1200 },
    bullet: { level: 0 },
    spacing: { line: 276, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Compliance to industry standards and security best practices.",
            size: 24,
            font: "Calibri",
            bullet: { level: 0 },
            color: '0f0f3f',
            italics: false
        })
    ]
})